export interface ClubSeasonResult {
  season: '2025' | '2025/26'
  position: number
  teams: number
  previousDivision: 1 | 2
  champion?: boolean
  promoted?: boolean
  relegated?: boolean
}

/**
 * Última temporada completa. Europa y Arabia usan 2025/26; América y MLS, 2025.
 * Los clubes ausentes se tratan como modestos hasta que se incorpore una fuente verificable.
 */
export const CLUB_SEASON_RESULTS: Readonly<Record<string, ClubSeasonResult>> = {
  // España
  'Barcelona': { season: '2025/26', position: 1, teams: 20, previousDivision: 1, champion: true },
  'Atlético Madrid': { season: '2025/26', position: 4, teams: 20, previousDivision: 1 },
  'Celta Vigo': { season: '2025/26', position: 6, teams: 20, previousDivision: 1 },
  'Getafe': { season: '2025/26', position: 7, teams: 20, previousDivision: 1 },
  'Espanyol': { season: '2025/26', position: 11, teams: 20, previousDivision: 1 },
  'Athletic Bilbao': { season: '2025/26', position: 12, teams: 20, previousDivision: 1 },
  'Deportivo Alavés': { season: '2025/26', position: 14, teams: 20, previousDivision: 1 },
  'Elche': { season: '2025/26', position: 15, teams: 20, previousDivision: 1 },
  'Levante': { season: '2025/26', position: 16, teams: 20, previousDivision: 1 },
  'Deportivo de A Coruña': { season: '2025/26', position: 2, teams: 22, previousDivision: 2, promoted: true },

  // Inglaterra
  'Arsenal': { season: '2025/26', position: 1, teams: 20, previousDivision: 1, champion: true },
  'Aston Villa': { season: '2025/26', position: 4, teams: 20, previousDivision: 1 },
  'Bournemouth': { season: '2025/26', position: 6, teams: 20, previousDivision: 1 },
  'Brighton and Hove Albion': { season: '2025/26', position: 8, teams: 20, previousDivision: 1 },
  'Brentford': { season: '2025/26', position: 9, teams: 20, previousDivision: 1 },
  'Chelsea': { season: '2025/26', position: 10, teams: 20, previousDivision: 1 },
  'Fulham': { season: '2025/26', position: 11, teams: 20, previousDivision: 1 },
  'Everton': { season: '2025/26', position: 13, teams: 20, previousDivision: 1 },
  'Crystal Palace': { season: '2025/26', position: 15, teams: 20, previousDivision: 1 },
  'Coventry City': { season: '2025/26', position: 1, teams: 24, previousDivision: 2, champion: true, promoted: true },

  // Italia
  'Inter Milan': { season: '2025/26', position: 1, teams: 20, previousDivision: 1, champion: true },
  'Como': { season: '2025/26', position: 4, teams: 20, previousDivision: 1 },
  'AC Milan': { season: '2025/26', position: 5, teams: 20, previousDivision: 1 },
  'Juventus': { season: '2025/26', position: 6, teams: 20, previousDivision: 1 },
  'Atalanta': { season: '2025/26', position: 7, teams: 20, previousDivision: 1 },
  'Bologna': { season: '2025/26', position: 8, teams: 20, previousDivision: 1 },
  'Cagliari': { season: '2025/26', position: 14, teams: 20, previousDivision: 1 },
  'Fiorentina': { season: '2025/26', position: 15, teams: 20, previousDivision: 1 },
  'Genoa': { season: '2025/26', position: 16, teams: 20, previousDivision: 1 },
  'Frosinone': { season: '2025/26', position: 2, teams: 20, previousDivision: 2, promoted: true },

  // Alemania
  'Bayern Munich': { season: '2025/26', position: 1, teams: 18, previousDivision: 1, champion: true },
  'Borussia Dortmund': { season: '2025/26', position: 2, teams: 18, previousDivision: 1 },
  'Hoffenheim': { season: '2025/26', position: 5, teams: 18, previousDivision: 1 },
  'Bayer Leverkusen': { season: '2025/26', position: 6, teams: 18, previousDivision: 1 },
  'Freiburg': { season: '2025/26', position: 7, teams: 18, previousDivision: 1 },
  'Eintracht Frankfurt': { season: '2025/26', position: 8, teams: 18, previousDivision: 1 },
  'Augsburg': { season: '2025/26', position: 9, teams: 18, previousDivision: 1 },
  'Borussia Mönchengladbach': { season: '2025/26', position: 12, teams: 18, previousDivision: 1 },
  'Hamburg': { season: '2025/26', position: 13, teams: 18, previousDivision: 1 },
  'Elversberg': { season: '2025/26', position: 2, teams: 18, previousDivision: 2, promoted: true },

  // Francia
  'Lens': { season: '2025/26', position: 2, teams: 18, previousDivision: 1 },
  'Lille': { season: '2025/26', position: 3, teams: 18, previousDivision: 1 },
  'Lyon': { season: '2025/26', position: 4, teams: 18, previousDivision: 1 },
  'Marseille': { season: '2025/26', position: 5, teams: 18, previousDivision: 1 },
  'Lorient': { season: '2025/26', position: 10, teams: 18, previousDivision: 1 },
  'Brest': { season: '2025/26', position: 12, teams: 18, previousDivision: 1 },
  'Angers': { season: '2025/26', position: 13, teams: 18, previousDivision: 1 },
  'Le Havre': { season: '2025/26', position: 14, teams: 18, previousDivision: 1 },
  'Auxerre': { season: '2025/26', position: 15, teams: 18, previousDivision: 1 },
  'Le Mans': { season: '2025/26', position: 2, teams: 18, previousDivision: 2, promoted: true },

  // Argentina — tabla anual 2025
  'Aldosivi': { season: '2025', position: 28, teams: 30, previousDivision: 1 },
  'Argentinos Juniors': { season: '2025', position: 3, teams: 30, previousDivision: 1 },
  'Atlético Tucumán': { season: '2025', position: 25, teams: 30, previousDivision: 1 },
  'Banfield': { season: '2025', position: 21, teams: 30, previousDivision: 1 },
  'Barracas Central': { season: '2025', position: 10, teams: 30, previousDivision: 1 },
  'Belgrano': { season: '2025', position: 20, teams: 30, previousDivision: 1 },
  'Boca Juniors': { season: '2025', position: 2, teams: 30, previousDivision: 1 },
  'Central Córdoba de Santiago del Estero': { season: '2025', position: 14, teams: 30, previousDivision: 1 },
  'Defensa y Justicia': { season: '2025', position: 18, teams: 30, previousDivision: 1 },
  'Deportivo Riestra': { season: '2025', position: 6, teams: 30, previousDivision: 1 },

  // Brasil
  'Athletico Paranaense': { season: '2025', position: 2, teams: 20, previousDivision: 2, promoted: true },
  'Atlético Mineiro': { season: '2025', position: 11, teams: 20, previousDivision: 1 },
  'Bahia': { season: '2025', position: 7, teams: 20, previousDivision: 1 },
  'Botafogo': { season: '2025', position: 6, teams: 20, previousDivision: 1 },
  'Bragantino': { season: '2025', position: 10, teams: 20, previousDivision: 1 },
  'Chapecoense': { season: '2025', position: 3, teams: 20, previousDivision: 2, promoted: true },
  'Corinthians': { season: '2025', position: 13, teams: 20, previousDivision: 1 },
  'Coritiba': { season: '2025', position: 1, teams: 20, previousDivision: 2, champion: true, promoted: true },
  'Cruzeiro': { season: '2025', position: 3, teams: 20, previousDivision: 1 },
  'Flamengo': { season: '2025', position: 1, teams: 20, previousDivision: 1, champion: true },

  // Uruguay — tabla anual 2025
  'Albion': { season: '2025', position: 1, teams: 14, previousDivision: 2, champion: true, promoted: true },
  'Boston River': { season: '2025', position: 6, teams: 16, previousDivision: 1 },
  'Central Español': { season: '2025', position: 2, teams: 14, previousDivision: 2, promoted: true },
  'Cerro': { season: '2025', position: 10, teams: 16, previousDivision: 1 },
  'Cerro Largo': { season: '2025', position: 9, teams: 16, previousDivision: 1 },
  'Danubio': { season: '2025', position: 11, teams: 16, previousDivision: 1 },
  'Defensor Sporting': { season: '2025', position: 5, teams: 16, previousDivision: 1 },
  'Deportivo Maldonado': { season: '2025', position: 5, teams: 14, previousDivision: 2, promoted: true },
  'Juventud Las Piedras': { season: '2025', position: 4, teams: 16, previousDivision: 1 },
  'Liverpool Montevideo': { season: '2025', position: 3, teams: 16, previousDivision: 1 },

  // MLS — tabla general 2025
  'Atlanta United': { season: '2025', position: 29, teams: 30, previousDivision: 1 },
  'Austin FC': { season: '2025', position: 15, teams: 30, previousDivision: 1 },
  'CF Montréal': { season: '2025', position: 28, teams: 30, previousDivision: 1 },
  'Charlotte FC': { season: '2025', position: 7, teams: 30, previousDivision: 1 },
  'Chicago Fire': { season: '2025', position: 13, teams: 30, previousDivision: 1 },
  'Colorado Rapids': { season: '2025', position: 21, teams: 30, previousDivision: 1 },
  'Columbus Crew': { season: '2025', position: 12, teams: 30, previousDivision: 1 },
  'DC United': { season: '2025', position: 30, teams: 30, previousDivision: 1 },
  'FC Cincinnati': { season: '2025', position: 2, teams: 30, previousDivision: 1 },
  'FC Dallas': { season: '2025', position: 16, teams: 30, previousDivision: 1 },

  // Arabia Saudí
  'Al-Ahli': { season: '2025/26', position: 3, teams: 18, previousDivision: 1 },
  'Al-Ettifaq': { season: '2025/26', position: 7, teams: 18, previousDivision: 1 },
  'Al-Fateh': { season: '2025/26', position: 11, teams: 18, previousDivision: 1 },
  'Al-Fayha': { season: '2025/26', position: 10, teams: 18, previousDivision: 1 },
  'Al-Hazem': { season: '2025/26', position: 9, teams: 18, previousDivision: 1 },
  'Al-Hilal': { season: '2025/26', position: 2, teams: 18, previousDivision: 1 },
  'Al-Ittihad': { season: '2025/26', position: 5, teams: 18, previousDivision: 1 },
  'Al-Khaleej': { season: '2025/26', position: 12, teams: 18, previousDivision: 1 },
  'Al-Kholood': { season: '2025/26', position: 14, teams: 18, previousDivision: 1 },
  'Al-Najma Unaizah': { season: '2025/26', position: 18, teams: 18, previousDivision: 1, relegated: true },
}

export const CLUB_RESULT_SOURCES = {
  spain: ['https://www.laliga.com/en-GB/laliga-easports/standing', 'https://www.laliga.com/en-ES/laliga-hypermotion/standing'],
  england: ['https://www.premierleague.com/en/tables/premier-league/2025-26/all-matchweeks', 'https://www.efl.com/news/2026/april/21/sky-bet-championship--coventry-city-are-the-champions/'],
  italy: ['https://www.legaseriea.it/en/serie-a/classifica', 'https://www.legab.it/seriebkt/classifiche'],
  germany: ['https://www.bundesliga.com/en/bundesliga/table/2025-2026', 'https://www.bundesliga.com/en/2bundesliga/table?view=full/'],
  france: ['https://ligue1.com/en/competitions/ligue1mcdonalds/standings', 'https://ligue1.fr/en/competitions/ligue2bkt?tab=standings'],
  argentina: ['https://www.rsssf.org/tablesa/arg2025.html'],
  brazil: ['https://www.rsssf.org/tablesb/braz2025.html'],
  uruguay: ['https://www.rsssf.org/tablesu/uru2025.html'],
  mls: ['https://en.wikipedia.org/wiki/2025_Major_League_Soccer_season#Overall_table'],
  saudiArabia: ['https://www.spl.com.sa/en/standings', 'https://www.spl.com.sa/en/news/757084/introducing-the-2025-26-rsl-new-boys'],
} as const
